/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  COMPONENT_POPULATION,
  COMPONENT_POPULATION_METHOD,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { COMPONENT_POPULATION_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import { modelTypesById } from '#src/js/constants/models/modelTypes/index.js';
import Main from './Main.jsx';

const { CUSTOM } = COMPONENT_POPULATION_METHOD_VALUES;
const mapStateToProps = (state, ownProps) => {
  const { form, modelType } = ownProps;
  const { selectIsAutofilledFormField, selectFormValues } = modelTypesById[modelType];
  const componentPopulationMethod = selectFormValues(state, COMPONENT_POPULATION_METHOD);

  return {
    form,
    canAddComponent: !selectIsAutofilledFormField(state, { name: COMPONENT_POPULATION }),
    showCustomWarning: componentPopulationMethod === CUSTOM,
  };
};

export default connect(mapStateToProps)(Main);
